const items = [
  "Premium Botanical Ingredients",
  "Designed for Male Reproductive Health",
  "Supports Semen Volume & Libido",
  "60 Capsules | 30 Day Supply",
  "Made for Daily Use",
];

export default function MarqueeSection() {
  return (
    <div
      data-testid="marquee-section"
      style={{
        backgroundColor: '#1B3D7E',
        padding: '18px 0',
        overflow: 'hidden',
      }}
    >
      <div style={{ display: 'flex', overflow: 'hidden' }}>
        <div className="marquee-track">
          {[...items, ...items].map((text, i) => (
            <span
              key={`${text}-${i}`}
              style={{
                fontFamily: 'Outfit, sans-serif',
                fontSize: '0.7rem',
                fontWeight: 700,
                letterSpacing: '0.35em',
                textTransform: 'uppercase',
                color: 'rgba(255,255,255,0.45)',
                whiteSpace: 'nowrap',
              }}
            >
              {text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
